import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { translationPropType } from '@eventbrite/i18n';

import { Button } from '@eventbrite/eds-button';

export default class FormSubmitButton extends React.PureComponent {
    static propTypes = {
        buttonCTA: translationPropType.isRequired,
        submitDisabled: PropTypes.bool,
        buttonClasses: PropTypes.string,
        onClick: PropTypes.func,
        dataAutomation: PropTypes.string,
        dataHeapId: PropTypes.string,
        style: PropTypes.string,
        size: PropTypes.string,
        __containerClassName: PropTypes.string,
    };

    static defaultProps = {
        onClick: noop,
        style: 'fill',
        dataAutomation: 'form-submit-button',
        size: 'block',
    };

    render() {
        const {
            buttonCTA,
            submitDisabled,
            buttonClasses,
            onClick,
            dataAutomation,
            dataHeapId,
            style,
            size,
            isLoading,
            __containerClassName,
        } = this.props;

        return (
            <div className={buttonClasses}>
                <Button
                    onClick={onClick}
                    type="submit"
                    style={style}
                    size={size}
                    disabled={submitDisabled}
                    isLoading={isLoading}
                    data-automation={dataAutomation}
                    data-heap-id={dataHeapId}
                    __containerClassName={__containerClassName}
                >
                    {buttonCTA}
                </Button>
            </div>
        );
    }
}
